import { createAction } from '@reduxjs/toolkit'
import { BattleData } from './reducer'
import { Battle } from '../../types/battle'

export const updateBattles = createAction<{ data: Battle[] }>('battle/updateBattles')
